// Copyright (c) 2017 Deere & Company

export default Object.freeze({
    CREATE_PIP_HISTORY_REPORT_AG_GRID_API: 'CREATE_PIP_HISTORY_REPORT_AG_GRID_API',
    RESET_PIP_HISTORY_REPORT: 'RESET_PIP_HISTORY_REPORT',
    RESET_PIP_HISTORY_REPORT_CRITERIA: 'RESET_PIP_HISTORY_REPORT_CRITERIA',
    RESET_PIP_HISTORY_REPORT_IS_SCROLLABLE: 'RESET_PIP_HISTORY_REPORT_IS_SCROLLABLE',
    TOGGLE_PIP_HISTORY_REPORT_IS_SCROLLABLE: 'TOGGLE_PIP_HISTORY_REPORT_IS_SCROLLABLE',
    UPDATE_PIP_HISTORY_REPORT: 'UPDATE_PIP_HISTORY_REPORT',
    UPDATE_PIP_HISTORY_REPORT_CRITERIA: 'UPDATE_PIP_HISTORY_REPORT_CRITERIA',
    UPDATE_PIP_HISTORY_REPORT_SHOW_NO_RESULTS_FOUND: 'UPDATE_PIP_HISTORY_REPORT_SHOW_NO_RESULTS_FOUND'
});



// WEBPACK FOOTER //
// ./src/reports/pip-history/actions-list.js